const freeGift = {
  data: {
    updates: {},
    sections: [],
    sections_url: window.location.pathname,
  },
  check() {
    fetch('/cart', {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(response => response.json())
      .then(cart => {
        const totalPrice = cart.items.reduce((total, item) => total + item.price * item.quantity, 0)
        const tiers = freeGiftTiers
        const totalTiers = tiers.length

        if (!freeGiftTierInclusive) {
          let variantToAdd = null

          // Determine which variant to add based on the total price
          for (let i = totalTiers; i > 0; i--) {
            if (totalPrice >= tiers[i - 1].threshold) {
              variantToAdd = tiers[i - 1].variantId
              break
            }
          }

          this.data.sections = this.getSections()

          // Update cart items
          tiers.forEach(tier => {
            if (variantToAdd === tier.variantId) {
              if (!cart.items.find(item => item.variant_id == tier.variantId)) {
                this.add(tier.variantId, this.data.sections)
              }
              this.data.updates[tier.variantId] = 1
            } else {
              this.data.updates[tier.variantId] = 0
            }
          })
        } else {
          this.data.sections = this.getSections()

          // Update cart items
          tiers.forEach(tier => {
            if (totalPrice >= tier.threshold) {
              if (!cart.items.find(item => item.variant_id == tier.variantId)) {
                this.add(tier.variantId, this.data.sections)
              }
              this.data.updates[tier.variantId] = 1
            } else {
              if (cart.items.find(item => item.variant_id == tier.variantId)) {
                this.data.updates[tier.variantId] = 0
              }
            }
          })
        }
        this.update(this.data)
      })
      .catch(e => {
        console.error(e)
      })
  },
  add(variantId, sections) {
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      body: JSON.stringify({
        'quantity': 1,
        'id': variantId,
        'sections': sections,
        'sections_url': window.location.pathname
      })
    })
    .then(response => response.json())
    .then(data => {
      const miniCart = document.querySelector('mini-cart')

      if (miniCart) {
        miniCart.renderContents(data)
      }
    })
    .catch(e => {
      console.error(e)
    })
  },
  update(data) {
    const miniCart = document.querySelector('mini-cart')

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      miniCart.renderContents(data)
    })
    .catch(e => {
      console.error(e)
    })
  },
  getSections() {
    const miniCart = document.querySelector('mini-cart')
    return miniCart
      ? miniCart.getSectionsToRender().map(section => section.id)
      : []
  },
  format(tiers) {
    try {
      if (!tiers) return null
      return tiers.map(tier => {
        const [amount, variantId, productId] = tier.trim().split(':')
        return { 
          threshold: Number(amount) * 100,
          variantId: Number(variantId),
          productId: Number(productId) 
        }
      })
    } catch {
      return null
    }
  }
}
